export default __webpack_public_path__ + "static/media/leaf.a83fb554.png";